export default __webpack_public_path__ + "static/media/vehicle.1540e35e.png";